import React from 'react';
import BasketPageSection from "./BasketPageSection";

interface MenuSectionProps {
}

const MenuSection = (props: MenuSectionProps) => {
  return (
    <BasketPageSection
      image={'webapp-flex2.jpg'}
      gradientPosition={'left'}
      title='Kies zelf'
      subTitle='het menu'
      sideOverlayPosition={"left"}
      sideOverlay={
        <div
          className="surface-card border-1 border-200 border-round-2xl shadow-3 p-3 md:p-4"
          style={{
            background: 'rgba(255,255,255,0.88)',
            backdropFilter: 'blur(10px)',
          }}
        >
          <div
            className="inline-flex align-items-center gap-2 px-3 py-2 border-round-3xl mb-3"
            style={{ background: 'var(--orange-20)' }}
          >
            <i className="pi pi-sliders-h" />
            <span className="font-medium">Personaliseer je pakket</span>
          </div>

          <p className="text-lg font-bold color-orange mt-0 mb-2">
            Personaliseer je eigen pakket
          </p>

          <p className="text-gray-600 line-height-3 mb-3">
            Pas je pakket eenvoudig aan via onze webapp. Voeg extra groenten toe, vergroot je porties of verwijder wat je
            liever niet wil.
          </p>

          <div className="flex justify-content-end">
            <a
              className="px-3 py-2 bg-orange text-white overflow-hidden font-bold border-round-3xl no-underline"
              href="https://www.mijnboer.be/groentegeweld/inschrijven/pakketten"
            >
              Schrijf me in
            </a>
          </div>
        </div>
      }
    >
      <div className='grid align-items-center'>
        <div className="col-12 md:col-8">
          <p className="text-lg color-orange font-medium mb-2">
            Kies je eigen menu of laat je verrassen door de selectie van de boer.
          </p>

          <p className="line-height-3 mb-2">
            Elke week stellen wij een pakket samen met de pure smaken die het veld te bieden heeft.
            <span className="font-bold color-green"> Laat je verrassen </span>
            door de boeren en ontdek nieuwe groenten, heerlijke smaken en de lekkerste gerechten.
          </p>

          <p className="line-height-3 mb-0">
            <span className="font-bold color-green">Bepaal jij liever zelf</span> het menu, dan personaliseer je gewoon
            je pakket.
          </p>
        </div>

        <div className="col-12 md:col-4">
          <div
            className="border-round-2xl p-3 h-full"
            style={{
              background: 'linear-gradient(135deg, rgba(116, 143, 86, 0.12) 0%, rgba(238, 122, 49, 0.10) 100%)',
            }}
          >
            <div className="flex align-items-center gap-2 mb-2">
              <i className="pi pi-check-circle color-orange text-xl" />
              <span className="font-bold color-green">Elke week keuze</span>
            </div>
            <p className="line-height-3 mb-0">
              Je kiest uit een gevarieerd aanbod van seizoensgebonden groenten.
            </p>
          </div>
        </div>
      </div>
    </BasketPageSection>
  );
};

export default MenuSection;
